export enum SubNamespace {
  Concept = "Concept",
  RentHouse = "RentHouse",
  FindJob = "FindJob",
  BuyTicket = "BuyTicket",
  BuyCar = "BuyCar",
  BuyInsurance = "BuyInsurance",
  BuyHouse = "BuyHouse",
  SaleFurniture = "SaleFurniture",
  SaleCar = "SaleCar",
  TradeCar = "TradeCar",
  Bargain = "Bargain",
}

export enum SubGameType {
  simpleSearchConcept,
  simpleSearch,
  advancedSearch,
  sale,
  trade,
}

export const SceneConst = {
  rentHouse: {
    price: 1000,
    houses: [
      {
        name: "纯银时代",
      },
      {
        name: "银泰百货",
      },
      {
        name: "世贸华庭",
      },
      {
        name: "映像春天",
      },
      {
        name: "金色雅居",
      },
      {
        name: "红色物业",
      },
    ],
    convenient: {
      MIN: 2e3,
      MAX: 4e3,
    },
  },
  findJob: {
    jobs: [
      {
        name: "嘀哩哩",
      },
      {
        name: "嘟嘟打车",
      },
      {
        name: "小蓝书",
      },
      {
        name: "科大迅速",
      },
      {
        name: "南山居",
      },
      {
        name: "搜鱼",
      },
    ],
    salary: {
      MEAN: 6e3,
      STD: 1e3,
    },
  },
  buyTicket: {
    airlines: [
      {
        company: "西蜀航空",
        time: "上午",
        lockPrice: 100,
      },
      {
        company: "荆楚航空",
        time: "上午",
        lockPrice: 50,
      },
      {
        company: "吴越航空",
        time: "上午",
      },
      {
        company: "西蜀航空",
        time: "下午",
        lockPrice: 100,
      },
      {
        company: "荆楚航空",
        time: "下午",
        lockPrice: 50,
      },
      {
        company: "吴越航空",
        time: "下午",
      },
    ],
    days: 6,
    price: {
      MEAN: 1e3,
      STD: 200,
    },
  },
  buyCar: {
    cars: [
      {
        name: "大众",
      },
      {
        name: "起亚",
      },
      {
        name: "丰田",
      },
      {
        name: "福特",
      },
      {
        name: "雪佛兰",
      },
      {
        name: "雪铁龙",
      },
    ],
    price: {
      MIN: 14,
      MAX: 16,
    },
    discount: {
      MIN: 2,
      MAX: 0,
    },
    utility: {
      MIN: 15,
      MAX: 20,
    },
  },
  buyInsurance: {
    insurances: [
      {
        name: "基础套餐I",
        base: true,
      },
      {
        name: "基础套餐II",
        base: true,
      },
      {
        name: "小康型套餐",
      },
      {
        name: "2020新款经济型套餐",
      },
      {
        name: "经济型III系列套餐",
      },
      {
        name: "安心保A类套餐",
      },
      {
        name: "安心保B类套餐",
      },
      {
        name: "无忧果套餐",
      },
    ],
    price: {
      MIN: 4500,
      MAX: 5500,
    },
    utility: {
      MEAN: 1e4,
      STD: 2e3,
    },
  },
  buyHouse: {
    houses: [
      {
        name: "绿岛2046",
      },
      {
        name: "绮霞苑",
      },
      {
        name: "双柳新居",
      },
      {
        name: "逝水年华",
      },
      {
        name: "东海岸",
      },
      {
        name: "平门府",
      },
    ],
    price: {
      MEAN: 150,
      STD: 10,
    },
    discount: {
      MIN: 1,
      MAX: 5,
    },
    deposit: {
      MIN: 1.2,
      MAX: 1.8,
    },
    utility: {
      MEAN: 200,
      STD: 15,
    },
  },
  saleFurniture: {
    cost: 1000,
    buyerAmount: 100,
    utility: {
      MIN: 1500,
      MAX: 3000,
    },
  },
  saleCar: {
    cost: 10,
    searchCost: 1,
    buyerAmount: 100,
    price: {
      MIN: 10,
      MAX: 30,
    },
    utility: {
      MIN: 20,
      MAX: 40,
    },
  },
  bargain: {
    cost: 3e3,
    price: {
      MIN: 4e3,
      MAX: 6e3,
    },
    utility: {
      MIN: 6e3,
      MAX: 8e3,
    },
  },
};

export const Const = {
  casUsernamePrefix: "cas_",
};
